import * as am5 from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated'
import am5themes_Responsive from '@amcharts/amcharts5/themes/Responsive'
import * as am5radar from '@amcharts/amcharts5/radar'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { getServerCore } from '../../../../../utils'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { showSuccessSnackbar } from '../../../Snackbar/snackbar.action'

const { serverUrls } = getServerCore()
const authUrl = serverUrls.getAuthUrl()

const TEST_DATA = {
  minValue: 100,
  maxValue: 200,
  currentValue: 149,
}

const DIAGRAM_TOKEN_SPACE = 40000
const INPUT_INFO = {
  DEF:
    'Please enter how many Grams of Gold you want to invest in 100 grams steps',
  MAX_EXCEED: 'Maximum gold amount exceeded',
  NOT_DIVISBLE: 'The number is not a multiple of 100',
  REQUIRED: 'No Input',
}

// <------------------------------< Helpters >------------------------------>
const _getDiagramInitialData = (currentAllocatedTokens, grams) => {
  const minValue = Math.floor(+currentAllocatedTokens - DIAGRAM_TOKEN_SPACE)
  const maxValue = Math.floor(+currentAllocatedTokens + DIAGRAM_TOKEN_SPACE)
  return { minValue, maxValue, currentValue: currentAllocatedTokens, grams }
}

const _getTokenPrice = (tokens) => (tokens - 1) * 0.000000003725
const _formatPrice = (price) => price.toFixed(2)

const _formatDecimal = (num) => +(Math.round(num * 1000) / 1000).toFixed(3)

// const _calculateEstimation = () => true // todo: maybe improvements

const _getDetailedDiagData = (startIndex, emissionArray, endIndex = null) => {
  const start = startIndex - 1
  let end = endIndex ? endIndex - 1 : startIndex + 49
  end = end > 30200 ? 30200 : end
  const detailedArray = emissionArray.slice(start, end)

  const data = detailedArray.map((element, index) => {
    return { gold: (start + index + 1) * 100, token: element }
  })

  return data
}

// <--------------------------------< View >-------------------------------->
const TipTokensPricesView = ({soldTokens}) => {
  const lastTokenEmitted = Math.ceil(soldTokens)
  const nextTokenToEmit = lastTokenEmitted + 1
  const lastTokenGoldPrice = _getTokenPrice(lastTokenEmitted)
  const nextTokenGoldPrice = _getTokenPrice(nextTokenToEmit)

  return <>
    <div className="row row-cols-1 row-cols-md-2 mt-3 px-6">
        <div className=" col mt-3 lst-user-em-token">
          <h4>Last Token Emitted</h4>
          <div>
            Token Number:{' '}
            <span style={{ fontWeight: 'bold' }}>{lastTokenEmitted}</span>
          </div>
          <div>
            Token Gold Price:{' '}
            <span style={{ fontWeight: 'bold' }}>
              {lastTokenGoldPrice} grams
            </span>
          </div>
          <div style={{ fontSize: '1.2rem', fontWeight: 800 }}>
            Token price: {_formatPrice(lastTokenGoldPrice * 61.74)} USD
          </div>
        </div>
        <div className="col mt-3 nxt-user-em-token">
          <h4>Next Token to be Emitted</h4>
          <div>
            <span style={{ fontWeight: 'bold' }}>Token Number:</span>{' '}
            {nextTokenToEmit}
          </div>
          <div>
            <span style={{ fontWeight: 'bold' }}>Token Gold Price:</span>{' '}
            {nextTokenGoldPrice} grams
          </div>
          <div style={{ fontSize: '1.2rem', fontWeight: 800 }}>
            Token Price: {_formatPrice(nextTokenGoldPrice * 61.74)} USD
          </div>
        </div>
      </div>
  </>
}

const EstimationDiagram = ({ userInput, data }) => {
  useLayoutEffect(() => {
    let root = am5.Root.new('chartdiv2')

    root.setThemes([
      am5themes_Animated.new(root),
      am5themes_Responsive.new(root),
    ])

    const chart = root.container.children.push(
      am5radar.RadarChart.new(root, {
        panX: false,
        panY: false,
        startAngle: -180,
        endAngle: 0,
        layout: root.verticalLayout,
      }),
    )

    chart.getNumberFormatter().set('numberFormat', '#.##a')
    // chart.set(
    //   'scrollbarX',
    //   am5.Scrollbar.new(root, {
    //     orientation: 'horizontal',
    //   }),
    // )

    // ====> Measurement #1
    const axisRenderer = am5radar.AxisRendererCircular.new(root, {
      strokeOpacity: 0.1,
      minGridDistance: 100,
    })

    // axisRenderer.labels.template.setAll({
    //   radius: 15,
    // })

    axisRenderer.grid.template.setAll({
      visible: false,
    })

    const axis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 0,
        min: data.minValue,
        max: data.maxValue,
        strictMinMax: true,
        renderer: axisRenderer,
      }),
    )

    // ====> create range
    const createRange = (start, end, color, innerRadius, label = null) => {
      const rangeDataItem = axis.makeDataItem({
        value: start,
        endValue: end,
      })

      const range = axis.createAxisRange(rangeDataItem)

      rangeDataItem.get('axisFill').setAll({
        visible: true,
        fill: color,
        fillOpacity: 0.8,
        innerRadius,
      })

      rangeDataItem.get('tick').setAll({
        visible: false,
      })

      if (label) {
        rangeDataItem.get('label').setAll({
          text: label,
          inside: true,
          radius: innerRadius / -2 - 5,
          fontSize: '0.9em',
          fill: am5.color(0xffffff),
        })
      }
    }

    createRange(data.minValue, data.currentValue, '#3e4ab8', -40)

    if (userInput) {
      createRange(
        data.currentValue,
        data.currentValue + +userInput,
        '#7880cd',
        -35,
        _formatDecimal(userInput),
      )
      createRange(data.currentValue + +userInput, data.maxValue, '#b2b7e3', -20)
    } else {
      createRange(data.currentValue, data.maxValue, '#b2b7e3', -20)
    }

    // ====> create hands
    const createLabel = (x, y, value, bgColor) => {
      chart.seriesContainer.children.push(
        am5.Label.new(root, {
          fill: '#ffffff',
          x: x,
          y: y,
          centerX: am5.percent(50),
          textAlign: 'center',
          centerY: am5.percent(0),
          fontWeight: 'bold',
          fontSize: '1.5rem',
          text: `${value}`,
          background: am5.RoundedRectangle.new(root, {
            fill: '#3e4ab8',
          }),
        }),
      )
    }

    createLabel(0, -60, _formatDecimal(data.currentValue), '#19F307')
    // createLabel(0, -40, 600, '#9fb7ea')

    // ====> create hands
    const createHand = (value, color) => {
      const handDataItem = axis.makeDataItem({
        value,
      })

      const hand = handDataItem.set(
        'bullet',
        am5xy.AxisBullet.new(root, {
          sprite: am5radar.ClockHand.new(root, {
            radius: am5.percent(90),
            innerRadius: am5.percent(70),
          }),
        }),
      )

      hand.get('sprite').pin.setAll({
        forceHidden: true,
      })

      hand.get('sprite').hand.setAll({
        fill: color,
        fillOpacity: 0.9,
      })

      axis.createAxisRange(handDataItem)

      return hand
    }

    createHand(data.currentValue, '#3e4ab8')
    if (userInput) {
      createHand(+userInput + data.currentValue, '#7880cd')
    }

    return () => {
      root.dispose()
    }
  }, [userInput, data])

  return (
    <div div="p-3 my-3">
      <h3 className="fn_s_18 f-w-500 color_blk">
        Tokens you get for {data.grams || 0} Grams Gold
      </h3>
      <div
        id="chartdiv2"
        className="mb-6"
        style={{ width: '100%', height: 400 }}
      ></div>
    </div>
  )
}

const EmissionDetailedDiagram = ({ data }) => {
  useLayoutEffect(() => {
    // Create root element
    let root = am5.Root.new('colChart')

    // Set themes
    root.setThemes([am5themes_Animated.new(root)])

    // Create chart
    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: 'panX',
        wheelY: 'zoomX',
      }),
    )

    // Add cursor
    let cursor = chart.set(
      'cursor',
      am5xy.XYCursor.new(root, {
        behavior: 'zoomX',
      }),
    )
    cursor.lineY.set('visible', false)

    // Create axes
    const xRenderer = am5xy.AxisRendererX.new(root, {})

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: 'gold',
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {
          labelText: '[bold]{category}[/][verticalAlign: super;]th[/] gram',
          autoTextColor: true,
        }),
      }),
    )

    xAxis.data.setAll(data)
    xRenderer.labels.template.set(
      'text',
      '{gold}[verticalAlign: super;]th[/] [bold]Grams[/]',
    )

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        numberFormat: "#' [bold]QRFID Gold[/]'",
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: data[data.length - 1]['token'] - 700,
      }),
    )

    // Add series
    let series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: 'Series',
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: 'token',
        categoryXField: 'gold',
        tooltip: am5.Tooltip.new(root, {
          labelText: '{valueY} QRFID Gold',
        }),
      }),
    )

    series.set('fill', '#7880cd')

    // // Add scrollbar
    // chart.set(
    //   'scrollbarX',
    //   am5.Scrollbar.new(root, {
    //     orientation: 'horizontal',
    //   }),
    // )

    series.data.setAll(data)

    // Make stuff animate on load
    series.appear(1000)
    chart.appear(1000, 100)

    return () => {
      root.dispose()
    }
  }, [data])

  return (
    <>
      {/* <h3 className="fn_s_18 f-w-500 color_blk mt-6">
        Estimated Tokens/100 grams
      </h3> */}
      <div id="colChart" style={{ width: '100%', height: 400 }}></div>
    </>
  )
}

export const TokenEstimationTab = (props) => {
  const { user } = useSelector((state) => state.auth, shallowEqual)

  const [userInput, setUserInput] = useState('')
  const [stateData, setStateData] = useState()
  const [tokenEstimationData, setTokenEstimationData] = useState()
  const [tokenEstimation, setTokenEstimation] = useState()
  const [isInputInvalid, setIsInputInvalid] = useState(false)
  const [inputInfo, setInputInfo] = useState(INPUT_INFO.DEF)
  const [maxGoldAvailable, setMaxGoldAvailable] = useState()
  const [detailedTokenData, setDetailedTokenData] = useState()
  const [isEstimating, setIsEstimateing] = useState(false)

  const maxFixer = 6000
  const maxDistance = 45000

  const dispatch = useDispatch()

  useEffect(() => {
    getTokenEstimationData()
  }, [])

  const getTokenEstimationData = async (grams) => {
    try {
      const { _id } = user
      const { data } = await axios({
        method: 'GET',
        url: `${authUrl}/getTokenEstimation/${_id}?toBuyInGrams=${grams || ''}`,
      })
      if (data.responseCode && data.responseCode != 200) {
        return dispatch(
          showSuccessSnackbar(
            'error',
            data.responseMessage || 'Something went wrong',
            3000,
          ),
        )
      }

      const {
        currentIndex,
        DetailedArray,
        currentAllocatedTokens,
        currentGoldAmountSold,
        toBuyIndex,
      } = data.responseData

      setStateData(_getDiagramInitialData(currentAllocatedTokens, grams))

      setMaxGoldAvailable(3020000 - currentGoldAmountSold)

      toBuyIndex
        ? setDetailedTokenData(
            _getDetailedDiagData(currentIndex, DetailedArray, toBuyIndex),
          )
        : setDetailedTokenData(
            _getDetailedDiagData(currentIndex, DetailedArray),
          )

      setTokenEstimationData(data.responseData)

      return data.responseData
    } catch (error) {
      console.log('here')
      // dispatch(ProfileActions.resetPasswordError());
      return dispatch(
        showSuccessSnackbar(
          'error',
          error.responseMessage || 'Something went wrong',
          3000,
        ),
      )
    }
  }

  const handleChange = (event) => {
    const value = event.target.value
    setUserInput(value)
  }

  const handleSubmit = async () => {
    const value = Math.floor(userInput)

    // validate the input
    if (!value) {
      setInputInfo(INPUT_INFO.REQUIRED)
      return setIsInputInvalid(true)
    }

    if (!(Math.floor(value) % 100 === 0)) {
      setInputInfo(INPUT_INFO.NOT_DIVISBLE)
      return setIsInputInvalid(true)
    }

    if (value > maxGoldAvailable) {
      setInputInfo(INPUT_INFO.MAX_EXCEED)
      return setIsInputInvalid(true)
    }

    setInputInfo(INPUT_INFO.DEF)
    setIsInputInvalid(false)
    setIsEstimateing(true)

    // let currentEstimation = 0
    // let endIndex = 0

    // if (tokenEstimation) {
    //   _calculateEstimation()
    // } else {
    // }
    // // update detailed diagram data
    // setDetailedTokenData(_getDetailedDiagData(currentIndex, DetailedArray))

    // get info / caculate the estimation
    const { toBuyTokens } = await getTokenEstimationData(userInput)

    // update estimation
    const allocatedValue = Number(toBuyTokens) + stateData.currentValue

    if (stateData.maxValue - allocatedValue > maxDistance) {
      setStateData({
        ...stateData,
        maxValue: allocatedValue + maxFixer,
        grams: value,
      })
    }

    if (allocatedValue >= stateData.maxValue) {
      setStateData({
        ...stateData,
        maxValue: allocatedValue + maxFixer,
        grams: value,
      })
    }
    setTokenEstimation(toBuyTokens)
    setIsEstimateing(false)
  }

  return (
    <div className="container mt-6 text-center">
      {tokenEstimationData ? (
        <>
          <div className="row justify-content-center">
            <div class="input-group mb-3 col-sm-8 col-xl-6">
              <input
                value={userInput}
                onChange={handleChange}
                max={maxGoldAvailable}
                type="Number"
                class="form-control"
                placeholder="Amount of gold in grams"
                aria-label="Amount of gold in grams"
                aria-describedby="button-addon2"
              ></input>
              <button
                class="btn btn-primary"
                type="button"
                id="button-addon2"
                disabled={isEstimating}
                onClick={handleSubmit}
              >
                {isEstimating ? (
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                ) : (
                  <>Calculate Token</>
                )}
              </button>
            </div>
          </div>
          <div
            className={!isInputInvalid ? 'text-muted mb-6' : 'text-danger mb-6'}
          >
            {inputInfo}
          </div>
          <EstimationDiagram userInput={tokenEstimation} data={stateData} />
          <TipTokensPricesView soldTokens={stateData.currentValue}/>
          <EmissionDetailedDiagram data={detailedTokenData} />
        </>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  )
}
